import React from 'react';
import { Zoom } from '@material-ui/core';

import { Paragraph } from './sub-components/Paragraph';

export const About = () => {
  const content = {
    heading: 'About Me',
    para1: `I'm a 22-year-old student at <span><a href='https://www.sxccal.edu/' target='_blank' rel='noopener noreferrer'>St. Xavier's College (Autonomous), Kolkata</a></span>, currently in the final year of Master's degree in Computer Science. Besides college, I am doing a remote internship program as a <span>Back-End Developer</span> at <span><a href='https://www.linkedin.com/company/weanalyz/' target='_blank' rel='noopener noreferrer'>WeAnalyz</a></span>. `,
    para2:
      'I love books a lot. I love reading them, I love staring at them for hours.',
  };

  return (
    <div className='container' id='about'>
      <div className='flex-r-spbw'>
        <Paragraph content={content} showImg={true} />
        <div className='banner-wrapper hide-sm'>
          <img
            className='banner hide-sm'
            src='images/my-avatar-center-old.png'
            alt='Avatar of Soumya dey'
          ></img>
        </div>
        <Zoom in={true} timeout={400}>
          <div className='icons about-icons hide-sm'>
            <a
              href='https://github.com/Soumya-Dey'
              target='_blank'
              rel='noopener noreferrer'
            >
              <i
                className='fab fa-github'
                title="soumyadey's Github Profile"
              ></i>
            </a>

            <a
              href='https://dev.to/soumyadey'
              target='_blank'
              rel='noopener noreferrer'
            >
              <i className='fab fa-dev' title="soumyadey's DEV.to Profile"></i>
            </a>
          </div>
        </Zoom>
      </div>
    </div>
  );
};
